import axios from 'axios'
import getConfig from 'next/config'
import qs from 'qs'

export const createAxiosStrapiInstance = () => {
  const instance = axios.create({
    baseURL: getConfig()?.publicRuntimeConfig?.baseApiStrapiUrl,
  })

  instance.interceptors.request.use((config) => {
    const authToken = getConfig().publicRuntimeConfig.strapiToken

    if (authToken) {
      config.headers['Authorization'] = `Bearer ${authToken}`
    }

    // Преобразование квери-параметров для их повторения
    config.paramsSerializer = (params) =>
      qs.stringify(params, { arrayFormat: 'repeat' })

    return config
  })

  instance.interceptors.response.use(
    async (res) => {
      return res
    },
    async (error) => {
      return Promise.reject(error)
    }
  )

  return instance
}
